package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.deletePosts
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.DeleteRequest
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.PostsUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay


suspend fun CoroutineScope.deletePostsUseCase(
    postIds: List<String>,
    state: PostsUI,
    setState: (PostsUI) -> Unit,
): Boolean {
    val scope = this

    deletePosts(
        deleteRequest = DeleteRequest(
            ids = postIds,
            currentUser = null,
            requestPage = null
        )
    ).also { response ->


        delay(500)

        console.log(response)

        if (response!=null && response.data==true)  {
            setState(
                state.copy(
                    toastMessage = ToastMessage(
                        message = response.message?:"Elementos eliminados correctamente",
                        style = MyToastStyle.Success
                    )
                )
            ).also {
                scope.showMyToast(toastBasicID)
                return true
            }

        } else {
            setState(
                state.copy(
                    toastMessage = ToastMessage(
                        message = response?.message?:"Error al procesar la solicitud",
                        style = MyToastStyle.Danger
                    )
                )
            ).also {
                scope.showMyToast(toastBasicID)
            }
        }



    }

    return false
}